import { render, staticRenderFns } from "./anadirLeechero.vue?vue&type=template&id=3f9f8d1b&scoped=true&"
import script from "./anadirLeechero.vue?vue&type=script&lang=js&"
export * from "./anadirLeechero.vue?vue&type=script&lang=js&"
import style0 from "./anadirLeechero.vue?vue&type=style&index=0&id=3f9f8d1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f8d1b",
  null
  
)

export default component.exports